import { Inject, Component, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Sort } from '@angular/material/sort';
import { MatDrawer } from '@angular/material/sidenav'
import { compare } from '../helpers'
import { TrainingService } from '../training.service';

export interface Training {
  id: number;
  training: string;
}
 
@Component({
  selector: 'training',
  templateUrl: './manage-training.component.html',
  styleUrls: ['./manage-training.component.scss']
})

export class ManageTrainingComponent {

  @ViewChild('editDrawer') editDrawer!: MatDrawer;
  interestForm = new UntypedFormGroup({
    id: new UntypedFormControl({value: 0, disabled: true}),
    training: new UntypedFormControl('')
  });
  lastSort: Sort = { active: "training", direction: "asc" };
  editTraining: Training = {training: '', id: 0};
  subCategories: Training[] = [];
  sortedData: Training[];
  displayedColumns: string[] = ['id', 'training', 'edit'];

  constructor(public TrainingService: TrainingService) {
    this.sortedData = this.subCategories.slice();
    // this.TrainingService = TrainingService;
    TrainingService.query().subscribe(response => { 
      this.subCategories = response; 
      this.sortData(this.lastSort);
    });
  }

  sortData(sort: Sort) {
    this.lastSort = sort;
    const data = this.subCategories.slice();

    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction   === 'asc';
      switch (sort.active) {
        case 'id':           
          return compare(a.id, b.id, isAsc);
        case 'training':
          return compare(a.training, b.training, isAsc);
        default:
          return 0;
      }
    });
  }

  editRow(el) {
    console.log(el);
    this.interestForm.patchValue({
      id: el.id,
      training: el.training
    });
    this.editDrawer.toggle();
  }

  addRow() {
    this.interestForm.patchValue({
      id: 0,
      training: ''
    });
    this.editDrawer.toggle();
  }

  onSubmit() {
    if(this.interestForm.getRawValue().id === 0) { //new
      let subskill: any = {};
      subskill.training = this.interestForm.value.training;
      this.TrainingService.save(subskill).subscribe((res) => {
        this.TrainingService.query().subscribe(response => { 
          this.subCategories = response; 
          this.sortedData = this.subCategories.slice(); 
        });
      });
    } else { //edit
      this.TrainingService.get(this.interestForm.getRawValue().id).subscribe( subskill => {
        subskill.training =  this.interestForm.value.training;
        this.TrainingService.update(subskill).subscribe(response => { 
          let interests : Training[] = [ {
            id: response.id,
            training: response.training
          }]
    
          const existing = this.subCategories.reduce((a,t)=> (a[t.id] = t, a), {}),
          changed = interests.reduce((a,t)=> (a[t.id] = t, a), {})
    
          this.subCategories = Object.values({...existing, ...changed})
          // this.sortedData = this.subCategories.slice(); 
          this.sortData(this.lastSort);
        });
      });
      
    }
   
  }
  
}
